import { QRBlock as Component } from '@staffino/flow-controls';
import { FlowBlockQR as BlockModel } from '@staffino/model';
import React from 'react';
import { useTemplateRendererNoEscape } from '../use-template-renderer';
import usePropertyTranslation from '../use-property-translation-hook';

type Props = {
  block: BlockModel;
};

const QRBlock = ({ block }: Props) => {
  const translatedTitle = usePropertyTranslation(
    block.translations,
    'title',
    block.title,
  );
  const [value] = useTemplateRendererNoEscape(block.value);
  return <Component block={{ ...block, value, title: translatedTitle }} />;
};

export default QRBlock;
